<!-- <a (click)="buttonClicked()" class="btn btn-{{buttonSettings.colorSet}} btn-sm">
  <svg-icon *ngIf="iconSvg"
      [src]="iconSvg"
      class="svg-icon svg-icon-2"
    >
    </svg-icon>
  {{ buttonLabel }}
  </a>
 -->

<button
  *ngIf="!iconButton || smartButton"
  (click)="buttonClicked()"
  [class.custom-manage-button]="smartButton"
  class="btn btn-{{ size }} btn-{{ buttonSettings.colorSet }} hover-rotate-svg"
>
  <ul *ngIf="!!loading" class="d-flex flex-row m-0 p-0">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
  <span class="d-flex flex-center" *ngIf="!loading">
    <svg-icon
    *ngIf="iconSvg" [src]="iconSvg"
      class="svg-icon svg-icon-2"
    >
    </svg-icon>
    <span class="button-label">
    {{ buttonLabel }}
  </span>
  </span>
</button>

<button
  *ngIf="iconButton && !smartButton"
  (click)="buttonClicked()"
  class="btn btn-{{ size }} btn-icon btn-{{
    buttonSettings.colorSet
  }} hover-elevate-up hover-rotate-me hover-rotate-svg"
>
 
  <ul *ngIf="!!loading" class="d-flex flex-row m-0 p-0">
   <li style="background: #fff"></li>
   <li style="background: #fff"></li>
   <li style="background: #fff"></li>
 </ul>

 <svg-icon
 *ngIf="!loading"
   src="assets/svg/system/ai.svg?rand=1.2"
   class="svg-icon svg-icon-fluid mw-100 p-2"
 >
 </svg-icon>

  <!-- <img
    *ngIf="!loading"
    class="w-35px"
    src="assets/images/illustrations/thunder.svg?rand=1.2"
  /> -->
</button>
